import { render, staticRenderFns } from "./InfoN2.vue?vue&type=template&id=0078a208"
import script from "./InfoN2.vue?vue&type=script&lang=js"
export * from "./InfoN2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports